<template>
  <div class="app" v-title data-title="预订服务-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="4" />
    <div class="yj-banner rel">
      <img src="@/assets/images/yd-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">预订服务</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">预订服务</div>
        <div class="f17 ls3">Reservation Services</div>
      </div>
    </div>
    <div class="wz-notice mt50 pb50">
      <div class=" w1200 auto pb50">
        <div class="cell_bk tj f17 wz-notice-text lh20" v-if="data && data.Items && data.Items.length > 0" v-html="data.Items[0].ContentText">
        </div>
        <!-- <div class="cell_bk tj f17 wz-notice-text lh20">
          <h2 class="f32 b ts">贵宾服务</h2>
          <p>
          广富林文化遗址为到来的贵宾提供专业的接待讲解服务及尊享专属通道，全力为您服务。
          </p>
          <h3 class="f24 b">预定流程</h3>
          <strong>1、服务洽谈</strong><br>
          需双方商定服务要求，确认参观流程及路线，落实细节问题

          <p>
          <strong>2、服务方案</strong><br>
          ①　礼仪迎宾、全程陪同讲解参观（一团一导，每团最高限定接待30人）<br>
          ②　参观途中园区内可提供短程接驳电瓶车辆<br>
          ③　可享受园区内任意活动优先的服务<br>
          ④　园区内展馆免排队<br>
          ⑤　如有特殊要求，可提供个性化参观路线
          </p>
          <p>

          <strong>3、预订购买</strong><br>

          ①　网络预约：通过公众号或电话可提前预约<br>
          ②　现场预约：游客服务中心<br>

          </p>
          <p>
          <strong>4、接待流程</strong><br>

          ①　团队向接待部（窗口设在游客服务中心）提出讲解服务需求，客服人员登记团队接待信息，协调安排具体讲解员跟进此团队。<br>
          ②　讲解员带领团队至票务部缴费<br>
          ③　讲解员收取接待服务费票根后，进行全程陪同讲解<br>
          ④　接待完毕，向接待主管报备

          </p>
          <p>
          <strong>5、反馈售后服务</strong><br>

          《贵宾服务意见反馈表》

          </p>
          <p>
          <h3 class="f24 b">联系方式</h3>
          贵宾热线：021-57800000
          </p>

        </div> -->
      </div>

    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-ydfw-gbfw',
      data: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.data = data;
        }
      })
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/yuding/vip.vue